import * as React from "react"

import { Input } from "@/components/ui/input"
import { cn } from "@/lib/utils"

type MaskedCredentialInputProps = Omit<
  React.ComponentProps<typeof Input>,
  "type" | "autoComplete"
>

export const PROTECTED_CREDENTIAL_MASK = "********"

/**
 * Visually masks a write-only credential without exposing an HTML password
 * field that password managers may offer to save or autofill.
 */
export function MaskedCredentialInput({
  className,
  ...props
}: MaskedCredentialInputProps) {
  return (
    <Input
      {...props}
      type="text"
      autoComplete="off"
      autoCapitalize="none"
      autoCorrect="off"
      spellCheck={false}
      data-1p-ignore
      data-lpignore="true"
      data-bwignore
      data-form-type="other"
      className={cn("[-webkit-text-security:disc]", className)}
    />
  )
}
